import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Container } from 'reactstrap';
import ReceivingOrderInformation from './components/show/ReceivingOrderInformation';
import ReceivingOrderLineItems from './components/show/ReceivingOrderLineItems';
import ReceivingOrderReceivingShipments from './components/show/ReceivingOrderReceivingShipments';
import ShowContainer from '../../shared/components/show/ShowContainer';

const ReceivingOrdersShow = () => (
  <Container>
    <ShowContainer>
      {
        (resourceitem) => {
          if (Object.keys(resourceitem).length === 0) return null;
          return (
            <Container>
              <ReceivingOrderInformation resourceitem={resourceitem} />
              <hr />
              <ReceivingOrderLineItems resourceitem={resourceitem} />
              <hr />
              <ReceivingOrderReceivingShipments resourceitem={resourceitem} />
            </Container>
          );
        }
      }
    </ShowContainer>
  </Container>
);

export default withRouter(connect()(ReceivingOrdersShow));
